<template>
  <b-progress height="3rem" :max="progress.total">
    <b-progress-bar :value="progress.fullyPicked ? progress.total  : progress.unloaded" variant="info"></b-progress-bar>
<!--    <b-progress-bar :value="progress.notUnloaded" variant="info"></b-progress-bar>-->
    <b-progress-bar :value="progress.unscanable" variant="warning"></b-progress-bar>
  </b-progress>
</template>

<script>
  export default {
    name: 'progress-bar-incoming',
    props: ['progress'],
    computed: {},
    methods: {}
  }
</script>

<style lang="scss" scoped>
  .progress {
    border: 1px solid #e4e0e0;
  }

  .progress {
    background: white;
  }

  .bg-success {
    background: #00b954 !important;
  }

  .bg-info {
    background: #00c9ff !important
  }
</style>
